import { lazy } from "react";

const BoxList = lazy(()=> import("./BoxList"));
const CreateBox = lazy(()=> import('./CreateBox'));
const EditBox = lazy( () => import('./EditBox'));
const BoxBulkImport = lazy(() => import('./bulk-import/BoxBulkImport'));
const BoxBulkImportWizard = lazy(() => import('./bulk-import-wizard/BoxBulkImportWizard'));


const clientAdminRoutes = [
    {
        path: "/box/list",
        component: BoxList,
        key: "View_CoreBox"
    },
    {
        path: "/box/create",
        component: CreateBox,
        key: "Create_CoreBox"
    },
    {
        path: '/box/edit/:id',
        component: EditBox,
        key: "Edit_CoreBox"
    },
    {
        path: '/box/bulk-import',
        component: BoxBulkImport,
        key: "BulkImport_CoreBox"
    },
    {
        path: '/box/bulk-import-wizard',
        component: BoxBulkImportWizard,
        key: "View_CoreBoxBoxImportWizard"
    },
];



export default clientAdminRoutes;
